import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EquipmentService } from 'app/services/models/equipment.service';

@Component({
  selector: 'app-equipment-history-dialog',
  templateUrl: './equipment-history-dialog.component.html',
  styleUrls: ['./equipment-history-dialog.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class EquipmentHistoryDialogComponent implements OnInit {
  @Input() equipmentId: number;
  constructor(public activeModal: NgbActiveModal, private equipmentService: EquipmentService) { }
  equipment:any = {}
  async ngOnInit() {
    if(this.equipmentId != null){
      await this.getByIdEquipmentHistoryMovement(this.equipmentId);
    }
  }

  async getByIdEquipmentHistoryMovement(id){
    const data = await this.equipmentService.getByIdEquipmentHistoryMovement(id);
    console.log(data);
    this.equipment = data;
  }

  movementTypeMap: { [key: number]: string } = {
    1: 'Zimmetlendi',
    2: 'Zimmet Alındı',
    3: 'Servise Gönderildi',
    4: 'Hurda / İade',
    5: 'Arızalı',
    6: 'Kayıp'
  };
  
}